import React, { useImperativeHandle, useState } from 'react';
import api, { getCombinedTicker } from '../../api/api'
import { useSelector } from 'react-redux';
import { IGlobalState } from '../../model/IGlobalState';
import Tabs from '../Tabs';
import Mailchimp, { IMailChimpMethods } from './Mailchimp';
import TemplatesComponent, { ITemplateMethods } from '../templates/TemplatesComponent';
import ContactComponent from '../contacts/ContactComponent';
import CampaignPage, { ICampaignPageMethods } from './emailMarketing/CampaignPage';
import {  EmailMarketingProviderType } from '../../model/EmailMarketingProviderType';
import { EmailMarketingSettings } from '../../model/Stock';
import useAsyncEffect from 'use-async-effect';
import * as Roles from '../../model/Roles';
import { uppercaseFirstLetter } from '../../util/util';

interface IProps {
    tab?:string

}

export interface IEmailMarketingPageMethods {
    save: () => Promise<boolean>
    isDirty: () => boolean
}

const SettingsTabName:string = 'Settings';
const ContactsTabName:string = 'Contacts';
const TemplatesTabName:string = 'Templates';
const CampaignsTabName:string = 'Campaigns';

const EmailMarketingPage = React.forwardRef<any, IProps>((props: IProps, ref) => {

    const stock = useSelector((state: IGlobalState) => state.currentStock);
    const user = useSelector((state: IGlobalState) => state.user)
    const [settings, setSettings] = useState<EmailMarketingSettings>({} as any);
    const [ activeTab, setActiveTab ] = useState<string>(uppercaseFirstLetter(props.tab) || '');
    
    const settingsPage = React.createRef<IMailChimpMethods>();
    const templatesPage = React.createRef<ITemplateMethods>();
    const campaignPage = React.createRef<ICampaignPageMethods>();

    useAsyncEffect(async (isMounted:()=>boolean) => {

        const result = await api().getEmailMarketingSettings(stock.id);
        if(isMounted()){
            setSettings(result)
        }
    }, [])

    useImperativeHandle(ref, (): IEmailMarketingPageMethods => ({

        async save() {

            let success:boolean = false;
            if(activeTab === SettingsTabName){
                success = await settingsPage.current!.save();
            }else if(activeTab === TemplatesTabName){
                success = await templatesPage.current!.save();
            }else if(activeTab === CampaignsTabName){
                success = await campaignPage.current!.save();
            }
            return success;
        },

        // Route to the active sub-tab so leaving Email Marketing with unsaved edits warns.
        isDirty() {
            if(activeTab === SettingsTabName) return settingsPage.current ? settingsPage.current.isDirty() : false;
            if(activeTab === TemplatesTabName) return templatesPage.current ? templatesPage.current.isDirty() : false;
            if(activeTab === CampaignsTabName) return campaignPage.current ? campaignPage.current.isDirty() : false;
            return false;
        }

    }));
    

    const isMaileroo = settings.emailMarketingProviderType === EmailMarketingProviderType.Maileroo;
    const showSettings = Roles.IsAdminOrHasRole(user, stock.id, Roles.EditMailchimp);
    const showContacts = isMaileroo && showSettings;
    const showTemplates = isMaileroo && showSettings;
    const showCampaigns = isMaileroo && (showSettings || Roles.HasStockRole(user, Roles.CreateCampaign));

    return <>
    <Tabs onTabChanged={setActiveTab} activeTab={activeTab} >

                        { showSettings &&  
                        <div data-label={SettingsTabName}>
                           <Mailchimp 
                                ticker={getCombinedTicker(stock)} 
                                apiKey={stock.apiKey}
                                stockId={stock.id}
                                ref={settingsPage}
                        />
                        
                        </div>}
                       
                       { showContacts &&  <div data-label={ContactsTabName}>                          
                         <ContactComponent stockId={stock.id} />
                        </div>}
                      

                        { showTemplates && <div data-label={TemplatesTabName}>                          
                        <TemplatesComponent stockId={stock.id} ref={templatesPage} />
                        </div>}
                        
                        { showCampaigns && <div data-label={CampaignsTabName}>
                        <CampaignPage stockId={stock.id} ref={campaignPage} />
                        </div>}

                        
                       
    
                    </Tabs>
    </>
    
    
});

export default EmailMarketingPage